<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || routeName == 'profile_tax_and_payments'">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" v-if="routeName !== 'profile_tax_and_payments'">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Social Security Number</h1>
                    <p class="auth-subtext">Please provide your tax details to ensure compliance with IRS regulations
                        and accurate tax reporting</p>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <security-number label="Enter your Social Security Number (SSN)" :spaces="[5]" :dashes="[3]" />
                <!-- <el-form-item class="no-scroll" label="Do you have a corporation?">
                    <el-select class="corporation-select w-100" popper-class="normal-select"
                        v-model="formsData.userForm.tax_has_corporation.value" placeholder="Please select">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <div v-if="formsData.userForm.tax_has_corporation.value === 1">
                    <el-form-item class="no-scroll" label="How would you like to be taxed?">
                        <el-select class="corporation-select w-100"
                            v-model="formsData.userForm.taxed_as.value" placeholder="Please select">
                            <el-option label="As an individual" :value="1"></el-option>
                            <el-option label="As an corporation" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </div> -->
                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="isButtonDisabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles" v-if="isAustralia">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>

<script>
import SecurityNumberComp from "@/components/SecurityNumber/SecurityNumber";
import {
    onMounted,
    inject,
    computed,
    provide
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'

import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
        "security-number": SecurityNumberComp,
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const routeName = $route.name
        const setPageClassGlobal = inject('setPageClassGlobal');
        const userData = $store.getters.GET_USER_DATA;
        const isAustralia = isAustraliaRegion();

        console.log("🚀 ~ setup ~ userData:", userData)
        const formsDataArray = {
            userForm: {
                // tax_has_corporation: {
                //     value: userData.settings.taxHasCorporation || 0,
                //     valueImportant: true,
                //     validators: [{
                //         validator: (rule, formField, callback) => {
                //             formValidate.validate(rule, formField, 'hasCorporation', callback, setFormValidation);
                //         },
                //     }]
                // },
                // taxed_as: {
                //     value: userData.settings.taxedAs || 1,
                //     validators: [{
                //         validator: (rule, formField, callback) => {
                //             formValidate.validate(rule, formField, 'taxPaymentType', callback, setFormValidation);
                //         },
                //     }]
                // },
                social_security_number: {
                    value: userData.settings.socialSecurityNumber || '',
                    inputsValue: userData.settings.socialSecurityNumber ? userData.settings.socialSecurityNumber.split('') : [],
                    numberLength: 9,
                    currentInput: 0,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "socialSecurityNumber",
                                    callback,
                                    setFormValidation
                                );
                            },
                            trigger: ["enter"],
                        },
                    ],
                },
            }
        };

        const goBack = async() => {
            if (routeName == "profile_tax_and_payments") {
                $router.push({
                    name: 'profile_edit'
                })
            } else {
                // if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                //     $router.push({
                //         name: 'auth_contractor_rate',
                //     })
                // } else {
                //     $router.push({
                //         name: 'auth_id_eligibility'
                //     })
                // }
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            }


        };
        const isButtonDisabled = computed(() => {
            console.log(formsData.userForm.social_security_number.value.length)
            if (formsData.userForm.social_security_number.value.length !== 9) {
                return true;
            }

            for (let i = 0; i < formsData.userForm.social_security_number.inputsValue.length; i++) {
                if (!/^\d$/.test(formsData.userForm.social_security_number.inputsValue[i])) {
                    return true
                }
            }

            // if(formsData.userForm.tax_has_corporation.value === 0) {
            //     return false;
            // }
            return formsData.userForm.disabled;
        });

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            let formValues = getFormValues(formName);
                            formValues = {
                                ...formValues,
                                onboarding_step: "tax_payments"
                            };

                            // if (formValues.tax_has_corporation === 0) {
                            //     // remove taxed_as if tax_has_corporation is 0
                            //     delete formValues.taxed_as;
                            // }
                            await $store.dispatch('SAVE_USER_DATA', formValues);

                            if (routeName == "profile_tax_and_payments") {
                                
                                $router.push({
                                    name: 'profile_edit'
                                })
                            } else {
                                if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                                $store.dispatch("SAVE_USER_DATA", {
                                    survey: 1,
                                    hideLoading: true,
                                });
                                $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                                $router.push({
                                    name: "intro",
                                });
                            } else {
                                
                                $router.push({
                                    name: 'auth_software_experience',
                                });
                            }
                            }
                        } catch (error) {
                            console.error('Error submitting form:', error);
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                if(userData.isImported == 0){
                    try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                                $store.dispatch("SAVE_USER_DATA", {
                                    survey: 1,
                                    hideLoading: true,
                                });
                                $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                                $router.push({
                                    name: "intro",
                                });
                            } else {
                                
                                $router.push({
                                    name: 'auth_software_experience',
                                });
                            }
                } catch (error) {
                    console.log(error);
                }
                }else{
                    try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                                $store.dispatch("SAVE_USER_DATA", {
                                    survey: 1,
                                    hideLoading: true,
                                });
                                $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                                $router.push({
                                    name: "intro",
                                });
                            } else {
                                
                                $router.push({
                                    name: 'auth_software_experience',
                                });
                            }
                } catch (error) {
                    console.log(error);
                }
                }
               
            })();

        }

        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            checkFormValidation('userForm', false);
        });


        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        provide("checkFormValidation", checkFormValidation);
        provide("setFormValidation", setFormValidation);
        provide("formsRefs", formsRefs);
        provide("formName", 'userForm');
        provide("goNext", goNext);
        provide("securityNumber", formsData.userForm.social_security_number);

        return {
            formsData,
            checkFormValidation,
            goBack,
            goNext,
            isButtonDisabled,
            skip,
            routeName,
            isAustralia
        }
    },
}
</script>